module.exports = __webpack_public_path__ + "static/media/girasol.26bf0ef3.png";